// Extraído de PeticionDetail.jsx (refactor mecánico, sin cambios funcionales)
import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Copy } from "lucide-react";
import EspacioCombobox from "@/components/EspacioCombobox";

// ============ CLONAR LÍNEA DIALOG ============
export function ClonarLineaDialog({ open, setOpen, source, espacios, cloneEspacioId, setCloneEspacioId, cloneZonaId, setCloneZonaId, onCloned, clienteId }) {
  const [saving, setSaving] = useState(false);
  const espOrigen = espacios.find((e) => e.id === source?.espacio_id);
  const espDestino = espacios.find((e) => e.id === cloneEspacioId);
  const zonasDestino = espDestino?.zonas || [];

  const submit = async (e) => {
    e.preventDefault();
    if (!cloneEspacioId) return;
    setSaving(true);
    try {
      await api.post(`/lineas/${source.id}/clone`, {
        espacio_id: cloneEspacioId,
        zona_id: cloneZonaId || null,
      });
      setOpen(false);
      onCloned();
    } finally { setSaving(false); }
  };

  if (!source) return null;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-zinc-950 border-zinc-800 text-zinc-100 max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Copy className="w-5 h-5 text-blue-400" /> Clonar línea
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="bg-zinc-900/60 border border-zinc-800 rounded-lg p-3 text-xs space-y-1">
            <div className="text-zinc-500">Origen:</div>
            <div className="text-zinc-200 font-medium">{espOrigen?.nombre || "—"}</div>
            <div className="text-zinc-400">{source.descripcion || "(sin descripción)"}</div>
            <div className="text-blue-300 text-[11px] mt-2">
              Se copiarán todos los componentes y sub-componentes (resetea estado a pendiente).
            </div>
          </div>
          <div>
            <Label>Nuevo espacio *</Label>
              <EspacioCombobox
                value={cloneEspacioId}
                onChange={(v) => { setCloneEspacioId(v); setCloneZonaId(""); }}
                espacios={espacios}
                excludeId={source.espacio_id}
                clienteId={clienteId}
                placeholder="Selecciona el nuevo espacio…"
                testId="clone-espacio-select"
              />
          </div>
          {zonasDestino.length > 0 && (
            <div>
              <Label>Zona (opcional)</Label>
              <Select value={cloneZonaId} onValueChange={setCloneZonaId}>
                <SelectTrigger className="bg-zinc-900 border-zinc-800"><SelectValue placeholder="—" /></SelectTrigger>
                <SelectContent className="bg-zinc-950 border-zinc-800 text-zinc-100">
                  {zonasDestino.map((z) => (
                    <SelectItem key={z.id} value={z.id}>
                      {z.nombre} {z.ancho_cm && z.alto_cm ? `(${z.ancho_cm}×${z.alto_cm}cm)` : ""}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => setOpen(false)} className="bg-transparent border-zinc-700">Cancelar</Button>
            <Button type="submit" disabled={saving || !cloneEspacioId} data-testid="clone-confirm-btn"
              className="bg-blue-500 hover:bg-blue-400 text-zinc-900 font-semibold">
              {saving ? "Clonando..." : "Clonar línea"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
